<script setup>
import { useRoute } from "@js/utils/route";
import { ref } from "vue";

const props = defineProps({
  tenant: {
    type: Object,
    required: true,
  },
  callback: {
    type: Function,
    required: false,
  },
});

const { route } = useRoute();

const loading = ref(false);

function forceAction() {
  loading.value = true;

  let url = route("front.projectManagement.seo.postForceIndexationUrls", {
    tenant: props.tenant.id,
  });

  fetch(url, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest",
      "X-CSRF-TOKEN": document
        .querySelector('meta[name="csrf-token"]')
        .getAttribute("content"),
    },
    body: JSON.stringify({}),
  })
    .then(() => {
      loading.value = false;

      if (props.callback) {
        props.callback();
      }
    })
    .catch((error) => {
      console.error(error);
    });
}
</script>

<template>
  <slot name="button" :action="forceAction" :loading="loading" />
</template>
